import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaStudentTrainingApi } from '../api/studentTrainings/CharismaStudentTrainingApi.tsx';
import CharismaAbsenceForm from './absenceForm.tsx';
import CharismaFileForm from '../components/fileForm.tsx'
import { CharismaUserContext } from '../context.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import {formatDate} from '../utils.tsx'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaAbsencesList(props){
    
    interface absence{
        id: number,
        subject: string,
        fromtDate: string,
        toDate: string,
        attach: string
    }    
   
    const [create, setCreate] = React.useState(false);
    const [absencesList, setAbsencesList] = React.useState([]);
    const [deleteAbsences, setDeleteAbsences] = React.useState(false);
    const [selectedAbsences, setSelectedAbsences] = React.useState([]);   
    const [currentAbsence, setCurrentAbsence] = React.useState(null)
    const [absenceId, setAbsenceId] = React.useState(0)
    const [deleteId, setDeleteId] = React.useState(0)
   
    const lCurrentUser = React.useContext(CharismaUserContext);
    const lReadWrite = lCurrentUser !== null && lCurrentUser !== undefined;
    const lStudentTrainingId = props.studentTrainingId;    
    const lStudentId = props.studentId;    


    React.useEffect(()=>{
        const lResponsePeriods = CharismaStudentTrainingApi.ListAbsences(lStudentTrainingId);
        lResponsePeriods.then((value)=>{
            if(value.error === 0){
                setAbsencesList(value.absences);
            }
        }).catch((error)=>{
            
        })
    }, [lStudentTrainingId])
    
    
    function handleUpdateAbsence(pFromDate : string, pToDate : string, pSubject:string, pId: number){
        const lResponse = CharismaStudentTrainingApi.UpdateAbsence(pSubject, pFromDate, pToDate, pId);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.absence !== null){
                    let lAbsencesList = absencesList.slice()
                    for(let index = 0; index < lAbsencesList.length; index++){
                        let absence = lAbsencesList[index];
                        console.log(absence);
                        console.log(value.absence);
                        if (absence.id === value.absence.id){
                            lAbsencesList[index] = value.absence;
                            break;
                        }
                    }
                    console.log(lAbsencesList);
                    setAbsencesList(lAbsencesList);
                    setCreate(false);
                    setCurrentAbsence(null);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    }
          
    function handleCreateAbsence(pFromDate : string, pToDate : string, pSubject:string){
        const lResponse = CharismaStudentTrainingApi.CreateAbsence(pSubject, pFromDate, pToDate, lStudentId, lStudentTrainingId);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.absence !== null){
                    let lAbsences = absencesList.concat(value.absence);
                    setAbsencesList(lAbsences);
                    setCreate(false);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    } 
    
    function handleCancelCreate(){
        setCreate(false);
        setCurrentAbsence(null)
    }
                    
    function handleDeleteAbsences(){
        const lResponse = CharismaStudentTrainingApi.DeleteAbsences(selectedAbsences);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.ids !== null){
                    const lIds = value.ids;
                    let lAbsences = absencesList.filter((lAbsence)=>lIds.indexOf(lAbsence.id) === -1);
                    setAbsencesList(lAbsences);
                    setDeleteAbsences(false);                  
                }
;            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })           
    }            
    
    function handleSelectedAbsence(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selectedAbsences.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selectedAbsences, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selectedAbsences.slice(1));
            }
            else if(lIndex === selectedAbsences.length - 1){
                lNewSelected = lNewSelected.concat(selectedAbsences.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selectedAbsences.slice(0, lIndex), selectedAbsences.slice(lIndex + 1),);
            }
        }
        setSelectedAbsences(lNewSelected);
    }
    
    function handleSetJustified(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lJustified = 0;
        if(pEvent.target.checked){
            lJustified = 1;
        }
        const lResponse = CharismaStudentTrainingApi.JustifyAbsence(lJustified, pId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.assessment !== null){
                    const lAssessmentId = value.absence.id;
                    let lAbsences = absencesList.slice();
                    for(let lIndex = 0; lIndex < lAbsences.length; lIndex++){
                        if(lAbsences[lIndex].id === lAssessmentId){
                            lAbsences[lIndex].justified = value.absence.justified;
                            setAbsencesList(lAbsences);
                            break;
                            
                        }
                    }                  
                }
            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })          
    }    
            
    
    function handleCloseEdit(){
        setCurrentAbsence(null);
    }
    
    function handleEdit(pId : number){
          for(let lIndex = 0; lIndex < absencesList.length; lIndex++){
              const lAbsence = absencesList[lIndex];
              if(lAbsence.id == pId){
                  setCurrentAbsence(lAbsence);
                  break;
              }
          } 
    }
    
    function handleCancelDoc(){
        setAbsenceId(0);
    }
    
    function handleDeleteDoc(){
        const lResponse = CharismaStudentTrainingApi.DeleteAbsenceDoc(lStudentId, lStudentTrainingId, deleteId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.absence !== null){
                    setAbsenceId(0);     
                    let lAbsences = absencesList.slice();
                    for(let index = 0; index < lAbsences.length; index++){
                        if(lAbsences[index].id === value.absence.id){
                            lAbsences[index] = value.absence;
                            break
                        }
                    }            
                    setAbsencesList(lAbsences); 
                    setDeleteId(0);
                }
            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })  
    }
    
    function handleAddDoc(pFile: File){
        const lResponse = CharismaStudentTrainingApi.AddAbsenceDoc(lStudentId, lStudentTrainingId, pFile, absenceId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.absence !== null){
                    setAbsenceId(0);     
                    let lAbsences = absencesList.slice();
                    for(let index = 0; index < lAbsences.length; index++){
                        if(lAbsences[index].id === value.absence.id){
                            lAbsences[index] = value.absence;
                            break
                        }
                    }            
                    setAbsencesList(lAbsences); 
                }
            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })  
    }    
    
    function createAbsencesTable(pAbsences : absence[], pSelected : number[]){
        return(
            pAbsences.map((absence)=>(
                <TableRow key={absence.id}>
                    {lCurrentUser !== undefined && lCurrentUser.profile === 0 ?
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={pSelected.indexOf(absence.id) >= 0}
                                onClick={                                    
                                    (event)=>handleSelectedAbsence(event, absence.id)
                                    }
                            />
                        </TableCell>
                        :
                        null
                    }
                    <TableCell>
                        {absence.subject}
                    </TableCell>
                    <TableCell>
                        {formatDate(absence.fromDate)}
                    </TableCell>
                    <TableCell>
                        {formatDate(absence.toDate)}
                    </TableCell>
                    <TableCell>
                        {absence.link !== null ?
                            <div>
                                <Link to={absence.link} target="_blank" rel="noopener noreferrer" >
                                    <AttachFileIcon/>
                                </Link>
                                <IconButton onClick={()=>setDeleteId(absence.id)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </div>
                        :
                            <IconButton onClick={()=>setAbsenceId(absence.id)}>
                                <AddIcon/>
                            </IconButton>
                        }
                    </TableCell>
                    <TableCell>
                        <Checkbox
                            checked={absence.justified !== undefined ? absence.justified : false}
                            disabled={!lReadWrite}
                            onClick={                                    
                                (event)=>handleSetJustified(event, absence.id)
                                }
                        />                        
                    </TableCell>
                    {lReadWrite  ?
                        <TableCell padding="checkbox">
                            <IconButton
                                onClick={()=>handleEdit(absence.id)}
                            >
                                <EditIcon/>
                            </IconButton>
                        </TableCell>
                        :
                        null
                    }
                </TableRow>
                 
            ))
        )
    }
    
    
    return(
        
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Card>
                        <CardHeader
                            title="Absences"
                            action={
                                <div>
                                {lReadWrite?
                                <div>
                                <IconButton onClick={()=>setCreate(true)}>
                                    <AddIcon/>
                                </IconButton>
                                {selectedAbsences.length > 0?
                                    <IconButton onClick={()=>setDeleteAbsences(true)}>
                                        <DeleteIcon/>
                                    </IconButton>  
                                    :
                                    null
                                } 
                                </div>
                                :
                                null
                                }                                
                                </div>
                            }
                        />
                        <CardContent>
                            <Table>                               
                                <TableHead>
                                    <TableRow>
                                        {lCurrentUser !== undefined && lCurrentUser.profile === 0 ?
                                            <TableCell padding="checkbox">
                                                </TableCell>
                                              :
                                              null
                                        }
                                        <TableCell>Motif</TableCell>
                                        <TableCell>Du</TableCell>
                                        <TableCell>Au</TableCell>
                                        <TableCell>Justificatif</TableCell>
                                        <TableCell>Justifiée</TableCell>
                                        <TableCell padding="checkbox">
                                        </TableCell>                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    createAbsencesTable(absencesList, selectedAbsences)
                                }
                                </TableBody>
                            </Table>                            
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {create ?
                <CharismaAbsenceForm
                    handleSubmit={handleCreateAbsence}
                    handleCancel={handleCancelCreate}

                />
                :
                null    
            }    
            {currentAbsence !== null ?
                <CharismaAbsenceForm
                    absenceId = {currentAbsence.id}
                    handleSubmit={handleUpdateAbsence}
                    handleCancel={handleCancelCreate}
                    subject = {currentAbsence.subject}
                    fromDate = {currentAbsence.fromDate}
                    toDate = {currentAbsence.toDate}

                />
                :
                null
            }
            
            <Dialog
                open={deleteAbsences}
            >
                <DialogTitle>Suppression des absences</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement les absences sélectionnés?</Typography>
                    {
                        false?
                            <Alert severity='info'>Suppression en cours...</Alert>
                        :
                        null
                    }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteAbsences(false)}>
                        Annuler
                    </Button>
                    <Button onClick={handleDeleteAbsences}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={deleteId !== 0}
            >
                <DialogTitle>Suppression du document</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement la pièce jointe?</Typography>
                    
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteId(0)}>
                        Annuler
                    </Button>
                    <Button onClick={()=>handleDeleteDoc()}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>            
            {absenceId !== 0 ?
                <CharismaFileForm
                    title={'Ajout d\'un document'}
                    handleSubmit={handleAddDoc}
                    handleCancel={handleCancelDoc}
                 />
                 :
                 null
            }                     
        </Box>      
    );
    
    
}